'use client';

import { Fragment, useState } from 'react';

import { useFilters, useOverrides } from '../store';
import type { Flag } from '../types';
import css from './experiments.module.scss';
import { FeatureFlag } from './feature-flag';
import { Search } from './search';

interface Props {
    flags: Flag[];
}
export function Experiments({ flags }: Props) {
    const [search, setSearch] = useState('');
    const { overrides, filter } = useOverrides();
    const { category } = useFilters();

    return (
        <div className={css.section}>
            <Search search={search} onSearch={setSearch} />

            <div className={css.list}>
                {flags
                    .filter(
                        f =>
                            f.key.includes(search) &&
                            (!filter || f.key in overrides) &&
                            (category === 'all' || f.category === category)
                    )
                    .map(flag => (
                        <Fragment key={flag.key}>
                            <FeatureFlag flag={flag} />
                            <div className={css.divider} />
                        </Fragment>
                    ))}
            </div>
        </div>
    );
}
